import axios from 'axios'
import _ from 'lodash'
// import { param } from 'jquery'

const axiosInst = axios.create({
  baseURL: process.env.VUE_APP_HOST_URL,
  withCredentials: true,
})

const config = (commit) => {
  return {
    onUploadProgress: progressEvent => {
      commit('SET_LOADPROGRESS', { a:10, t:30, progressEvent })
    },
    onDownloadProgress: progressEvent => {
      commit('SET_LOADPROGRESS', { a:30, t:70 ,progressEvent })
    },
  }  
}

const state = {
  logined: false,
  loadingPercent: 0,
  clientURL: process.env.VUE_APP_CLIENT_URL,
  admin: null,
  test: null,

  accounts: [],
  loginAccountIndex: 0,
}

const getters = {
  logined: state => {
    return state.logined
  },
  loadingPercent: state => {
    return state.loadingPercent
  },
  loading: state => {
    return state.loadingPercent > 0
  },
  clientURL: state => {
    return state.clientURL
  },
  admin: state => {
    return state.admin
  },
  test: state => {
    return state.test
  },
  account: state => index => {
    return state.accounts[index]
  },
  nowAccount: state => {
    return state.accounts[state.loginAccountIndex]
  }
}

const mutations = {
  LOGIN (state) {
    state.logined = true
  },
  LOGOUT (state) {
    state.logined = false
  },
  RESET_LOADPROGRESS (state) {
    state.loadingPercent = 0
  },
  START_LOADPROGRESS (state) {
    state.loadingPercent = 10
  },
  SET_LOADPROGRESS (state, { a, t, progressEvent }) {
    state.loadingPercent = a + Math.floor((progressEvent.loaded * t) / progressEvent.total);
  },
  ADMIN_MODE (state, admin) {
    state.admin = admin
  },
  TEST_MODE (state, test) {
    state.test = test
  },
  SET_ACCOUNTS (state, data) {
    state.accounts = data
    state.loginAccountIndex = 0
  },
  UPDATE_ACCOUNTS (state, data) {
    state.accounts = _.map(state.accounts, (ac)=>{
      return _.find(data, { eno:ac.eno }) || ac
    })
  },
  SET_LOGININDEX (state, data) {
    state.loginAccountIndex = data
  }
}

const actions = {
  login ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('eno', data.eno)
    params.append('password', data.password)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=login', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        commit('ADMIN_MODE', !!response.data.admin)
        commit('SET_ACCOUNTS', response.data.accounts)
      return response.data
      })
  },
  new ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('class', data.class)
    params.append('password1', data.password1)
    params.append('password2', data.password2)
    params.append('keyword', data.keyword)
    params.append('player', data.player)
    params.append('nickname', data.nickname)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=new', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        commit('SET_ACCOUNTS', response.data.accounts)
        return response.data
      })
  },
  first ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=first', config(commit))
      .then((response) => {
        if (response.data.to === "TITLE"){
          // do nothing
        } else if(response.data.to === "MAIN") {
          commit('LOGIN')
          commit('ADMIN_MODE', !!response.data.admin)
          commit('SET_ACCOUNTS', response.data.accounts)
        }
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getMiniIcon ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=miniIcon', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  /*eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }]*/
  setMiniIcon ({ commit }, data) {
    const params = new URLSearchParams()
    data.forEach((elm) => {
      params.append(elm.value, elm.url)
    })
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=miniIcon', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getMove ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=move', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setMove ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('action', data.action||'')
    params.append('shout', data.shout)
    params.append('icon', data.icon||'')
    params.append('destination', data.destination)
    params.append('keyword', data.keyword)
    params.append('subAction', JSON.stringify(data.subAction))
    params.append('collectAction', JSON.stringify(data.collectAction))
    params.append('selectCard', JSON.stringify(data.selectCard))
    params.append('event', JSON.stringify(data.event))
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=move', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getMakingEvent ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=makingEvent', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setMakingEvent ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('name', data.actionName||'')
    params.append('status', data.plusStatus||'')
    params.append('up', data.bonusStatus||'')
    params.append('prepareCode', JSON.stringify(data.prepareCode))
    params.append('condition', JSON.stringify(data.condition))
    params.append('target', data.target)
    params.append('shotStatus', JSON.stringify(data.shotStatus))
    params.append('type', data.type)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=makingEvent', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getMainLog ({ commit }, params) {
    let opt = ''
    if(params.id){
      opt = '&eno='+params.id
    }
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=mainLog'+opt, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getBattleLog ({ commit }, params) {
    let opt = ''
    if(params.id){
      opt = '&key='+params.id
    }
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=battleLog'+opt, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getProfile ({ commit }, params) {
    let opt = ''
    if(params.id){
      opt = '&eno='+params.id
    }
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=profile'+opt, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setProfile ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('nickname', data.nickname)
    params.append('name', data.name)
    params.append('memo', data.memo)
    params.append('note', data.note)
    params.append('image', data.image)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=profile', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getCharacterList ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=character/list&limit=1000', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getTvLog ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=tvLog', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  signInTwitter({ commit }, params) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=signInTwitter&callback='+params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getSetting ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=setting', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setSetting ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('discordWebhook', data.discordWebhook||'')
    params.append('discordWebhookUpdateNotify', data.discordWebhookUpdateNotify)
    params.append('discordWebhookNoActionAlert', data.discordWebhookNoActionAlert)
    params.append('emergencyEscape', data.emergencyEscape||'')
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=setting', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getSpotList ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=spot/list', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getSpot ({ commit }, data) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=spot/edit&key='+data, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setSpot ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('name', data.name||'')
    params.append('bg', data.bg||'')
    params.append('indoor', data.indoor||0)
    params.append('rid', data.rid)
    params.append('lockEvent', data.lockEvent||0)
    params.append('link', JSON.stringify(data.link))

    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=spot/edit', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getAreaList ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=area/list', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getAreaDetail ({ commit }, data) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=area/detail&key='+data, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getWorldEdit ({ commit }, data) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=worldEdit&key='+data, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setWorldEdit ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('world', JSON.stringify(data.world))
    params.append('area', JSON.stringify(data.area))
    params.append('test', JSON.stringify(data.test))
    params.append('card', JSON.stringify(data.card))
    params.append('id', data.id)
    params.append('doTest', data.doTest||'')
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=worldEdit', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        if(data.doTest){
          commit('TEST_MODE', response.data.return)
          commit('ADMIN_MODE', !!response.data.admin)
          commit('SET_ACCOUNTS', response.data.accounts)
        }
        return response.data
      })
  },
  getMyWorld ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=myworld', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getTvAnnounce ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=tvAnnounce', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setTvAnnounce ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('log', JSON.stringify(data.log))
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=tvAnnounce', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getWorldList ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=world/list', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getWorld ({ commit }, data) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=world/detail&key='+data, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getCodePreview({ commit }, data){
    const params = new URLSearchParams()
    params.append('code', JSON.stringify(data.code))
    params.append('complement', data.complement)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=codePreview', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  executeDaily ({ commit }) {
    const params = new URLSearchParams()
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=daily', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  rollbackDaily ({ commit }) {
    const params = new URLSearchParams()
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=rollback', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getDiceBattle ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=diceBattle', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setDiceBattle ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('performance', JSON.stringify(data.performance))
    params.append('icon', JSON.stringify(data.icon))
    params.append('event', JSON.stringify(data.event))
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=diceBattle', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getCtrlCharacter ({ commit }, params) {
    let opt = ''
    if(params.id){
      opt = '&eno='+params.id
    }
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=ctrlCharacter'+opt, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  setCtrlCharacter ({ commit }, data) {
    let opt = ''
    if(data.id){
      opt = '&eno='+data.id
    }
    const params = new URLSearchParams()
    params.append('cardList', JSON.stringify(data.cardList))
    params.append('achievementList', JSON.stringify(data.achievementList))
    params.append('status', JSON.stringify(data.status))
    params.append('privilege', JSON.stringify(data.privilege))
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=ctrlCharacter'+opt, params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  getSubCharacter ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .get('/test.cgi?path=subchara', config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        return response.data
      })
  },
  entrySubCharacter ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('keyword', data.keyword)
    params.append('nickname', data.nickname)
    params.append('world', data.world)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=subchara', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        commit('SET_ACCOUNTS', response.data.accounts)
        return response.data
      })
  },
  deleteCharacter ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('nickname', data.deleteName)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=delete', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        if(response.data.error === '200 OK'){
          commit('LOGOUT')
        }
        return response.data
      })
  },
  change ({ commit }, data) {
    const params = new URLSearchParams()
    params.append('token', data.token)
    params.append('eno', data.eno)
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=change', params, config(commit))
      .then((response) => {
        commit('RESET_LOADPROGRESS')
        commit('ADMIN_MODE', !!response.data.admin)
        return response.data
      })
  },
  changeLoginIndex({ commit }, data){
    commit('SET_LOGININDEX', data)
  },
  logout ({ commit }) {
    commit('START_LOADPROGRESS')
    return axiosInst
      .post('/test.cgi?path=logout', null, config(commit))
      .then(() => {
        commit('RESET_LOADPROGRESS')
        commit('LOGOUT')
        commit('SET_ACCOUNTS', [])
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
